import React from "react";
import Marquee from "react-fast-marquee";

const brandImages = [
    { name: "KFC",              src: "/images/brands/KFC.png" },
    { name: "Novotel",          src: "/images/brands/Novotel.png" },
    { name: "The Park Hotels",  src: "/images/brands/Park.png" },
    { name: "UFO Cine Media",   src: "/images/brands/UFO.png" },
    { name: "Ambica",           src: "/images/brands/Ambica.png" },
    { name: "Flurys",           src: "/images/brands/Flurys.png" },
    { name: "GreenPark Hotels", src: "/images/brands/GreenPark.png" },
    { name: "ITC Hotels",       src: "/images/brands/ITC.png" },
];

const brandNames = [
    "KFC",
    "Novotel",
    "The Park Hotels",
    "UFO Cine Media",
    "Ambica",
    "Flurys",
    "GreenPark Hotels",
    "ITC Hotels",
];

const BrandScroll = () => {
    return (
        <section
            id="brands"
            data-testid="brands-section"
            className="bg-white border-t border-b border-black/15 py-8 md:py-10 overflow-hidden"
        >
            {/* Header */}
            <div className="px-6 md:px-12 lg:px-16 flex items-center gap-6 md:gap-10 mb-6 md:mb-8">
                <span className="text-[11px] tracking-[0.28em] uppercase font-bold text-[#E60000] flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#E60000]" />
                    Brands We've Worked With
                </span>
                <span className="hidden md:inline text-[11px] tracking-[0.22em] uppercase font-bold text-black/40">
                    — A partial list
                </span>
            </div>

            {/* Strip 1 — Brand Image Cards (Square Tiles) */}
            <Marquee
                speed={110}
                gradient={false}
                pauseOnHover={true}
                autoFill={true}
            >
                {brandImages.map((brand, i) => (
                    <div
                        key={`${brand.name}-${i}`}
                        data-testid={`brand-logo-${i}`}
                        className="mx-3 md:mx-4"
                    >
                        <div
                            className="
                                w-40 h-40 md:w-48 md:h-48
                                rounded-2xl
                                flex items-center justify-center
                                p-4 md:p-5
                                bg-white
                                transition-all duration-300
                                cursor-pointer
                            "
                        >
                            <img
                                src={brand.src}
                                alt={brand.name}
                                className="w-full h-full object-contain"
                            />
                        </div>
                    </div>
                ))}
            </Marquee>

            {/* Strip 2 — Brand Names */}
            <Marquee
                speed={90}
                direction="right"
                gradient={false}
                autoFill={true}
                className="mt-5 opacity-80"
            >
                {brandNames.map((b, i) => (
                    <div
                        key={`r-${b}-${i}`}
                        className="flex items-center px-8 md:px-12"
                    >
                        <span className="font-display font-medium uppercase tracking-tight text-xl md:text-2xl text-black/60 whitespace-nowrap">
                            {b}
                        </span>
                        <span className="ml-8 md:ml-12 w-1.5 h-1.5 rounded-full bg-[#E60000] shrink-0" />
                    </div>
                ))}
            </Marquee>
        </section>
    );
};

export default BrandScroll;
